import { FunctionComponent, useMemo } from 'react';
import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

export type FrameType = {
  className?: string;
  iconCalendar?: string;
  events?: string;
  upcomingEvents?: string;
  presentedBy?: string;
  href?: string;
  target?: string;
  /** Style props */
  frameBackgroundColor?: CSSProperties['backgroundColor'];
};

const Frame: FunctionComponent<FrameType> = ({
  className = '',
  iconCalendar,
  events,
  upcomingEvents,
  presentedBy,
  frameBackgroundColor,
  href = '#',
  target,
}) => {
  const Component = href
    ? // scrollTo sectionId is broken in the version of react-router-dom (LINK) we are using
      //  this is a temporary fix
      href?.startsWith('#')
      ? 'a'
      : Link
    : 'div';

  const frameStyle: CSSProperties = useMemo(() => {
    return {
      backgroundColor: frameBackgroundColor,
    };
  }, [frameBackgroundColor]);

  return (
    <Component
      to={href}
      href={href}
      target={target}
      className={`box-border flex flex-1 flex-col items-start justify-center gap-4 overflow-hidden rounded-2xl !p-6 text-left text-2xl [backdrop-filter:blur(8px)] sm:min-w-[270px] xl:min-w-[308px] ${className}`}
      style={frameStyle}
    >
      <img
        className='relative max-h-full w-8 object-cover sm:w-10 lg:w-12'
        alt=''
        src={iconCalendar}
      />
      <div className='flex items-center justify-between self-stretch'>
        <div className='flex flex-1 items-center justify-between gap-0 md:flex-wrap'>
          <div className='flex flex-col items-start justify-center gap-0 sm:gap-2'>
            <h3 className='relative !m-0 font-[inherit] text-[length:inherit] text-base font-semibold leading-[134%] tracking-[-0.5px] md:text-[24px] md:leading-[26px]'>
              {events}
            </h3>
            <div className='text-body-XXS sm:text-body-XS relative text-nowrap'>
              {upcomingEvents}
            </div>
          </div>
          <img
            className='max-h-full w-12 rounded-2xl sm:w-16 rtl:-rotate-180'
            loading='lazy'
            alt=''
            src={presentedBy}
          />
        </div>
      </div>
    </Component>
  );
};

export default Frame;
